import React from "react";

import Form from "./form";

import { connect } from "react-redux";
import { updatePeriods, reset } from "../../../../../redux/actions/manager/stat/evolution";

import {
    CACHE_UNIT,
    CACHE_CLIENT,
    CACHE_VENDOR,
    CACHE_SERVICE,
    CACHE_MANAGER,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getVendorsForSelect,
    getClientsForSelect,
    getUnitsForSelect,
    getServicesForSelect,
    getManagersForSelect,
} from "../../../../../redux/actions/cache/interface";

import {
    getProjectsWithOptForSelect,
    getPointsOfSaleWithOptForSelect,
} from "../../../../../redux/actions/cache/client";

import Loader from "../../../../../components/loader";

class Container extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadCache();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        const { loading, loaded } = this.props;
        return (
            <>
                <Loader loading={this.props.loading} />
                {!loading && loaded && <Form {...this.props} />}
            </>
        );
    }
}

const cacheList = [CACHE_CLIENT, CACHE_VENDOR, CACHE_UNIT, CACHE_SERVICE, CACHE_MANAGER];

function MapStateToProps(state) {
    return {
        loaded: isCacheLoaded(state, cacheList),
        loading: isCacheLoading(state, cacheList),

        vendors: getVendorsForSelect(state),

        clients: getClientsForSelect(state),
        projects: getProjectsWithOptForSelect(state),
        pointsOfSale: getPointsOfSaleWithOptForSelect(state),

        units: getUnitsForSelect(state),
        services: getServicesForSelect(state),
        managers: getManagersForSelect(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),

        updatePeriods: (form) => dispatch(updatePeriods(form)),
        reset: () => dispatch(reset()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
